

class CodeUtils {
    getText(type, code) {
        const data = this.getData(type);
        const appTypeData = data.find(appType => appType.code === code);
        const {text} = appTypeData || {};
        return text;
    }

    getData(type) {
        if (type === 'registrationDecision') {
            return registrationDecisions;
        } else if (type === 'signOff') {
            return signOffs;
        } else if (type ==='city') {
            return cities;
        } else if (type ==='certificationRegion') {
            return certificationRegions;
        } else if (type ==='registrationActivities') {
            return registrationActivities;
        } else if (type ==='identityType') {
            return identityTypes;
        } else if (type ==='certificationStandard') {
            return certificationStandards;
        } else if (type ==='twCertificationCategory') {
            return twCertificationCategories;
        } else if (type ==='usCertificationCategory') {
            return usCertificationCategories;
        } else if (type === 'euCertificationCategory') {
            return euCertificationCategories;
        } else if (type ==='processingProductIngredients') {
            return processingProductIngredients;
        } else if (type === 'cropLegalStatus') {
            return cropLegalStatuses;
        } else if (type === 'certificationCategory') {
            return certificationCategories;
        } else if (type === 'areaUnit') {
            return areaUnits;
        } else if(type === 'processingOperationType') {
            return processingOperationTypes;
        } else if (type === 'gender' ) {
            return genders;
        } else if (type === 'cropLandOwnership') {
            return cropLandOwnerships;
        } else if (type ==='cropSelfMadeWay') {
            return cropSelfMadeWays;
        } else if (type === 'cropNonCertificationFieldOperation') {
            return cropNonCertificationFieldOperations;
        } else if (type === 'appType') {
            return appTypes;
        } else if (type ==='processingLegalStatus') {
            return processingLegalStatuses;
        } else if (type ==='landPropertyType') {
            return landPropertyTypes;
        } else if (type==='originProof') {
            return originProofs;
        } else if (type==='nonPurchased') {
            return nonPurchases;
        } else if (type==='certifiedDocumentType') {
            return certifiedDocumentTypes;
        } else if (type==='offGroundScope') {
            return offGroundScopes;
        } else if (type==='twCertificationCategory') {
            return twCertificationCategories;
        } else if (type==='nopCertificationCategory') {
            return nopCertificationCategories;
        } else if (type==='euCertificationCategory') {
            return euCertificationCategories;
        } else if (type==='operatorType') {
            return operatorTypes;
        } else if (type==='specType') {
            return specTypes;
        } else if (type==='weightUnit') {
            return weightUnits;
        } else if (type==='usLabelType') {
            return usLabelTypes
        } else if (type === 'leaseType') {
            return leaseTypes;
        } else if (type === "country") {
            return countries;
        } else if (type==='materialType') {
            return materialTypes;
        } else if (type==='usMaterialType') {
            return usMaterialTypes;
        } else if (type==='offSiteStorageType') {
            return offSiteStorageTypes;
        } else if (type==='compositionLevel') {
            return compositionLevels;
        } else if (type==='processingFarmType') {
            return processingFarmTypes;
        } else if (type==='processingCropSource') {
            return processingCropSources;
        } else if (type==='processingCropOrganicType') {
            return processingCropOrganicTypes;
        } else if (type==='processingCropSeedTreatment') {
            return processingCropSeedTreatments;
        }  else if (type==='cropAssignmentActivity') {
            return cropAssignmentActivities;
        } else if (type==='cropDocumentCheckActivity') {
            return cropDocumentCheckActivities;
        } else if (type==='cropPhase') {
            return cropPhases;
        } else if (type==='processingPhase') {
            return processingPhases;
        } else if (type==='processingAssignmentActivity') {
            return processingAssignmentActivities;
        } else if (type==='processingDocumentCheckActivity') {
            return processingDocumentCheckActivities;
        } else if (type==='cropDocumentReviewActivity') {
            return cropDocumentReviewActivities;
        } else if (type=== `processingDocumentReviewActivity`){
            return processingDocumentReviewActivities;
        } else if (type==='fertilizerRegistrationType'){
            return fertilizerRegistrationTypes;
        } else if (type==='preventionRegistrationType'){
            return preventionRegistrationTypes;
        } else if (type==='cropInspectionActivity'){
            return cropInspectionActivity;
        } else if (type==='checklistType'){
            return checklistTypes;
        } else if (type==='whetherOption'){
            return whetherOptions;
        } else if (type==='certificationHistoryType'){
            return certificationHistoryType
        } else if (type==='processingInspectionActivity'){
            return processingInspectionActivities;
        } else if (type==='improvementDeadlineActivity'){
            return improvementDeadlineActivities;
        } else if (type==='processingAppType'){
            return processingAppTypes;
        } else if(type==='processingViolationDocReviewActivity'){
            return processingViolationDocReviewActivities;
        } else if(type==='month'){
            return months;
        } else if(type==='labelStyle'){
            return labelStyles;
        } else if(type==='labelShipping'){
            return labelShipping;
        } else if(type==='packingLabel'){
            return packingLabel;
        } else if(type==='cropFieldLevel'){
            return cropFieldLevels;
        } else if(type==='cropPackingUnit'){
            return cropPackingUnits;
        } else if(type==='processingChangeActivity'){
            return processingChangeActivities;
        } else if(type==='cropChangeActivity'){
            return cropChangeActivities;
        } else if(type==='processingInspectionS30Decision'){
            return processingInspectionS30Decisions;
        }
    }
}

const processingInspectionS30Decisions = [
    {code: "supplemented", text: "應再補件或補充說明"},
    {code: "agree", text: "擬同意其矯正"},
    {code: "uncompleted", text: "矯正未完成"},
]

//作物異動審查活動
const cropChangeActivities = [
    {code: "changeReview_S10", text: "文件審查"},
    {code: "changeReview_S20", text: "文件審查補件"},
    {code: "changeReview_S30", text: "確認文件審查補件"},
    {code: "changeReview_S40", text: "文審覆核"},
    {code: "changeReview_S50", text: "防治資材審查-資材管理員"},
    {code: "changeReview_S60", text: "防治資材審查-稽核股長"},
    {code: "changeReview_S70", text: "文審核決"},
    {code: "changeReview_S80", text: "驗證資料更新"}
]

//加工異動審查活動
const processingChangeActivities = [
    {code: "changeReview_S10", text: "異動審查"},
    {code: "changeReview_S20", text: "異動覆核"},
    {code: "changeReview_S30", text: "異動核決"},
    {code: "changeReview_S40", text: "異動審查補件"},
    {code: "changeReview_S50", text: "確認異動審查補件"},
    {code: "changeReview_S60", text: "補件超時覆核"},
    {code: "changeReview_S70", text: "補件超時核決"},
    {code: "changeReview_S80", text: "驗證資料更新"}
]

const cropPackingUnits = [
    {code: "gram", text: "公克"},
    {code: "tw-tael", text: "兩"},
    {code: "tw-catty", text: "台斤"},
    {code: "kilogram", text: "公斤"},
]

const cropFieldLevels = [
    {code: "organic", text: "有機"},
    {code: "transition", text: "轉型期"}
]

const packingLabel = [
    {code: "change", text: "有異動"},
    {code: "noChange", text: "無異動"}
]

const labelShipping = [
    {code: "self", text: "自取"},
    {code: "house", text: "宅配"}
]

const labelStyles = [
    {code: "sticker", text: "黏貼式"},
    {code: "overPrinter", text: "套印式"},
]

const processingViolationDocReviewActivities = [
    {code: "violationDocReview_S10", text: "製作驗證決定通知書"},
    {code: "violationDocReview_S20", text: "違規處理回覆"},
    {code: "violationDocReview_S30", text: "前行會議紀錄"}
]

//限期改善活動
const improvementDeadlineActivities = [
    {code: "improvementDeadline_S10", text: "申請者回覆"},
    {code: "improvementDeadline_S20", text: "限改派查"},
    {code: "improvementDeadline_S30", text: "安排限改時程"},
    {code: "improvementDeadline_S40", text: "填寫限改採樣資訊"},
    {code: "improvementDeadline_S50", text: "填寫限改查驗報告"},
    {code: "improvementDeadline_S60", text: "限改採樣測試報告"},
]

//加工採樣活動
const processingInspectionActivities = [
    {code: "inspection_S10", text: "填寫總結報告"},
    {code: "inspection_S20", text: "回覆矯正措施"},
    {code: "inspection_S30", text: "評估矯正措施"},
    {code: "inspection_S40", text: "確認矯正措施"},
    {code: "inspection_S50", text: "填寫檢查表"},
]

const certificationHistoryType = [
    {code: "reject", text: "退件"},
    {code: "temporaryTermination", text: "暫時終止"},
    {code: "termination", text: "終止驗證"},
    {code: "violation", text: "違規"},
    {code: "others", text: "其他"},
    {code: "none", text: "以上皆無"},
]

const whetherOptions = [
    {code: "yes", text: "是"},
    {code: "no", text: "否"}
]

//檢查表類別
const checklistTypes = [
    {code: "crop", text: "作物"},
    {code: "selfProduced", text: "自產農產加工"},
    {code: "group", text: "集團"}
]

//作物採樣活動
const cropInspectionActivity = [
    {code: "inspection_S10", text: "填寫總結報告"},
    {code: "inspection_S20", text: "回覆矯正措施"},
    {code: "inspection_S30", text: "評估矯正措施"},
    {code: "inspection_S40", text: "確認矯正評估"},
    {code: "inspection_S50", text: "分派檢查表工作"},
    {code: "inspection_S60", text: "填寫檢查表(多人)"},
    {code: "inspection_S70", text: "彙整檢查表"},
    {code: "inspection_S80", text: "填寫檢查表"},
    {code: "inspection_S90", text: "確認檢查表"},
]

const preventionRegistrationTypes = [
    {code: "noRegistration", text: "無登記"},
    {code: "pesticide", text: "農藥許可證"},
    {code: "planProtection", text: "植保免登記證"},
]

const fertilizerRegistrationTypes = [
    {code: "noRegistration", text: "無登記"},
    {code: "registered", text: "肥料登記字號"},
]

//加工文件審查活動
const processingDocumentReviewActivities = [
    {code: "documentReview_S10", text: "文件審查"},
    {code: "documentReview_S20", text: "安排查核時程"},
    {code: "documentReview_S30", text: "申請者補件"},
]

// 作物文件審查活動
const cropDocumentReviewActivities = [
    {code: "documentReview_S10", text: "文件審查"},
    {code: "documentReview_S20", text: "安排查核時程"},
    {code: "documentReview_S30", text: "申請者補件"},
]

const processingAssignmentActivities = [
    {code:'assignment_S010', text:'指派承辦人'}
]

const processingDocumentCheckActivities = [
    {code:'documentCheck_S010', text:'文件點檢'},
    {code:'documentCheck_S020', text:'文件點檢初核'},
    {code:'documentCheck_S030', text:'文件點檢覆核'},
    {code:'documentCheck_S040', text:'文件點檢核決'},
    {code:'documentCheck_S050', text:'文件點檢發文'},
    {code:'documentCheck_S070', text:'繳費逾期原因'},
    {code:'documentCheck_S080', text:'文件點檢補件'},
    {code:'documentCheck_S090', text:'了解未補件原因'},
    {code:'documentCheck_S100', text:'確認文件點檢補件'},
    {code:'documentCheck_S110', text:'確認申請者文件'},
    {code:'documentCheck_S120', text:'確認申請書'}
]

const processingPhases = [
    {code: 'assignment', text: '案件分派'},
    {code: 'documentCheck', text: '文件點檢'},
    {code: 'payment', text: '等待繳費'},
    {code: 'inspectArrangement', text: '派查安排'},
    {code: 'documentReview', text: '文件審查'},
    {code: 'falseInspection', text: '不實地查驗'},
    {code: 'inspection', text: "實地查驗"},
    {code: 'certificateDecision', text: '驗證決定'},
    {code: 'improvementDeadline', text: '限期改善'},
    {code: 'certificate', text: '製證'},
    {code: 'irregularEstablishReview', text: '不定追成案審核'},
    {code: 'changeReview', text: '異動審核'}
]

const cropPhases = [
    {code: 'assignment', text: '案件分派'},
    {code: 'documentCheck', text: '文件點檢'},
    {code: 'payment', text: '等待繳費'},
    {code: 'auditArrangement', text: '派查安排'},
    {code: 'documentReview', text: '文件審查'},
    {code: 'falseInspection', text: '不實地查驗'},
    {code:'inspection', text:'實地查驗'},
    {code: 'certificateDecision', text: '驗證決定'},
    {code: 'improvementDeadline', text: '限期改善'},
    {code: 'certificate', text: '製證'},
    {code: 'irregularEstablishReview', text: '不定追成案審核'},
    {code: 'changeReview', text: "異動審查"}
]

const cropAssignmentActivities = [
    {code:'assignment_S010', text:'指派承辦人'}
]

const cropDocumentCheckActivities = [
    {code:'documentCheck_S010', text:'文件點檢'},
    {code:'documentCheck_S020', text:'文件點檢初核'},
    {code:'documentCheck_S030', text:'文件點檢覆核'},
    {code:'documentCheck_S040', text:'文件點檢核決'},
    {code:'documentCheck_S050', text:'文件點檢發文'},
    {code:'documentCheck_S070', text:'繳費逾期原因'},
    {code:'documentCheck_S080', text:'文件點檢補件'},
    {code:'documentCheck_S090', text:'了解未補件原因'},
    {code:'documentCheck_S100', text:'確認文件點檢補件'},
    {code:'documentCheck_S110', text:'確認申請者文件'},
    {code:'documentCheck_S120', text:'確認申請書修改'}
]


//加工-作物-種子狀態
const processingCropSeedTreatments = [
    {code:'withoutMedication',text:'未用藥處理'},
    {code:'withMedication',text:'用藥處理'},
    {code:'geneticModification',text:'基改'}
]

//加工-作物-有機類別
const processingCropOrganicTypes = [
    {code:'organic', text:'有機'},
    {code:'nonOrganic', text:'非有機'},
]

//加工-作物-來源
const processingCropSources = [
    {code:'seeds', text:'種子Seeds'},
    {code:'seeding', text:'種苗Seeding'},
    {code:'plantingStock', text:'繁殖體Planting stock'}
]

//加工-作物-田區類別
const processingFarmTypes = [
    {code:'transition', text:'轉型期'},
    {code:'organic', text:'有機'}
]

//組成成分等級
const compositionLevels = [
    {code:'organic', text:'有機'},
    {code:'nonOrganic', text:'非有機'},
    {code:'water', text:'水'},
    {code:'salt', text:'鹽'}
]

//廠外儲藏區-儲藏物品
const offSiteStorageTypes = [
    {code:'rawMaterial', text:'原料'},
    {code:'finishedProduct', text:'成品'},
    {code:'semiFinishedProduct', text:'半成品'},
    {code:'others', text:'其他'}
]


//原料類別
const materialTypes=[
    {code:'organic', text:'有機'},
    {code:'organicTransition', text:'有機轉型期'}
]

//美國原料類別
const usMaterialTypes=[
    {code:'organic', text:'有機'},
    {code:'organicTransition', text:'有機轉型期'},
    {code:'nonOrganic', text:'非有機'},
    {code:'foodAdditive', text:'食品添加物'},
]

//加工-美國-產品標示類別
const usLabelTypes = [
    {code:'100Organic', text:'百分百有機'},
    {code:'organic', text:'有機'},
    {code:'useOrganic', text:'使用有機'}
]

//加工-規格-重量單位
const weightUnits = [
    {code:'kg', text:'kg'},
    {code:'g', text:'g'},
    {code:'L', text:'L'},
    {code:'mL', text:'mL'},
]

//規格種類
const specTypes = [
    {code:'retail', text:'零售'},
    {code:'nonRetail', text:'非零售'},
]

//加工-經營者型態
const operatorTypes = [
    {code:'personal', text:'個人'},
    {code:'company', text:'公司/商業登記'},
    {code:'team', text:'產銷班/合作社/登記農場'},
    {code:'others', text:'其他'},
]

//租約類型
const leaseTypes = [
    {code:'lease', text:'租約或土地使用同意書'},
    {code:'legal', text:'土地合法使用承諾聲明書'},
]

const twCertificationCategories = [
    {code:"crop", text:"作物"},
    {code:"processing", text:"加工"},
    {code:"packing", text:"分裝"},
    {code:"circulation", text:"流通"},
    {code:"privateLabel", text:"流通(自有品牌Private Label)"},
]

const nopCertificationCategories = [
    {code:"crop", text:"作物 Crops"},
    {code:"wildCrop", text:"野生採集 Wide Crops"},
    {code:"handling", text:"加工 Handling"},
    {code:"privateLabel", text:"加工(自有品牌Private Label)"},
]

const euCertificationCategories = [
    {code:"crop", text:"作物 Crop"},
    {code:"processing", text:"加工 Processing Food"},
    {code:"trader", text:"加工(出口商 Trader)"},
]

const offGroundScopes = [
    {code:'all', text:'全部'},
    {code:'partial', text:'部分'}
]

const certifiedDocumentTypes = [
    {code:'organic' ,text:"有機證明"},
    {code:'noMedicine', text:'無藥劑處理證明'},
    {code:'usePlan', text:'使用計畫(有使用藥劑處理或無法確認)'},
]

const originProofs = [
    {code:'outsourcingOrGift', text:"外購或親友贈送"},
    {code:'nonPurchased', text: '非外購'}
]

const nonPurchases = [
    {code:'selfRetained', text:"自留種子、種苗"},
    {code:'plantedManyYears', text:"已種植多年"}
]

const appTypes = [
    {code: 'initial', text: '初次', priority: 50},
    {code: 'renewal', text: '展延', priority: 40},
    {code: 'expanding', text: '增列', priority: 30},
    {code: 'change', text: '異動', priority: 20},
    {code: 'followUp1', text: '追蹤1', priority: 10},
    {code: 'followUp2', text: '追蹤2', priority: 10},
    {code: 'irregular', text: '不定追'},
]

const processingAppTypes = [
    {code: 'initial', text: '初次', priority: 50},
    {code: 'renewal', text: '展延', priority: 40},
    {code: 'expanding', text: '增列', priority: 30},
    {code: 'change', text: '異動', priority: 20},
    {code: 'followUp', text: '追蹤', priority: 10},
    {code: 'irregular', text: '不定追'}
]

const cropNonCertificationFieldOperations = [
    {code: 'friendly', text: '友善'},
    {code: 'conventional', text: '慣行'},
    {code: 'organic', text: "有機"}
]

const cropSelfMadeWays = [
    {code: 'doOem', text: '有幫他人代工'},
    {code: 'notDoOem', text: '沒有幫他人代工'}
]

const cropLandOwnerships = [
    {code: 'owned', text: '自有'},
    {code: 'nonOwned', text: '非自有'}
]

const genders = [
    {code: 'male', text: '男'},
    {code: 'female', text: '女'}
]

const areaUnits = [
    {code: 'acre', text: '英畝'},
    {code: 'ha', text: '公頃'},
    {code: 'mu', text: '市畝'}
]

const processingOperationTypes = [
    {code: 'exporter', text: '出口商'},
    {code: 'privateLabel', text: '自有品牌業者'},
    {code: 'processingHandling', text: '加工廠'},
    {code: 'farm', text: '農場'},
]

const registrationDecisions = [
    {code: 'approved', text: '符合'},
    {code: 'notApproved', text: '不符合'}
]

const signOffs = [
    {code: 'approval', text: '同意'},
    {code: 'reject', text: '退回'}
]

const certificationRegions = [
    {code: 'domestic', text: '境內'},
    {code: 'overseas', text: '境外'}
]

const identityTypes = [
    {code: 'individual', text: '個人驗證'},
    {code: 'group', text: '集團驗證'}
]

const registrationActivities = [
    {code: 'S10', text: '註冊資格審查'},
    {code: 'S20', text: '加工課報價'},
    {code: 'S30', text: '加工課報價覆核'},
    {code: 'S40', text: '加工課報價核決'},
    {code: 'S50', text: '作物課報價'},
    {code: 'S60', text: '作物課報價覆核'},
    {code: 'S70', text: '作物課報價核決'},
    {code: 'S80', text: '回覆報價結果'},
]

const certificationStandards = [
    {code: 'TW', text: '台灣(Taiwan)'},
    {code: 'US', text: '美國(NOP)'},
    {code: 'EU', text: '歐盟(EU)'}
]


const usCertificationCategories = [
    {code: 'crop', text: '作物'},
    {code: 'processing', text: '加工'},
    {code: 'processingLabel', text: '加工(自有品牌)'}
]

const processingProductIngredients = [
    {code: 'single', text: '單一成分'},
    {code: 'multiple', text: '多種成分'}
]


const cities = [
    {text:'臺北市', code:'taipei'},
    {text:'新北市', code:'newTaipeiCity'},
    {text:'桃園市', code:'taoyuan'},
    {text:'臺中市', code:'taichung'},
    {text:'臺南市', code:'tainan'},
    {text:'高雄市', code:'kaohsiung'},
    {text:'基隆市', code:'keelung'},
    {text:'新竹市', code:'hsinchu'},
    {text:'嘉義市', code:'chiayi'},
    {text:'新竹縣', code:'hsinchuCountry'},
    {text:'苗栗縣', code:'miaoli'},
    {text:'彰化縣', code:'changhua'},
    {text:'南投縣', code:'nantou'},
    {text:'雲林縣', code:'yunlin'},
    {text:'屏東縣', code:'pingtung'},
    {text:'宜蘭縣', code:'yilan'},
    {text:'花蓮縣', code:'hualien'},
    {text:'臺東縣', code:'taitung'},
    {text:'澎湖縣', code:'penghu'},
    {text:'金門縣', code:'kinmen'},
    {text:'連江縣', code:'lianjiang'}
]

const countries = [
    {text: "臺灣", code: "TW"}
]


const cropLegalStatuses = [
    {text: "自然人", code: "naturalPerson"},
    {text: "農民團體(例：合作社)", code: "farmerGroup"},
    {text: "農業產銷班", code: "makingTeam"},
    {text: "依法設立或登記之農場", code: "farm"},
    {text: "以農委會為目的事業主管機關之相關農業團體(例：農會)", code: "group"},
    {text: "農企業", code: "agribusiness"},
    {text: "私立學校經營之農場", code: "operatedByPrivateSchool"},
    {text: "機關（構）及公立學校經營之農場", code: "operatedByPublicSchool"}
];

const processingLegalStatuses = [
    {text: "個人經營", code: "saleProprietorship"},
    {text: "公司組織", code: "corporation"},
    {text: "合作社", code: "cooperative"},
    {text: "其他", code: "others"},
    {text: "農企業", code: "agribusiness"}
];

const certificationCategories = [
    {text: "作物", code: "crop"},
    {text: "加工/分裝流通", code: "processing"}
];

const landPropertyTypes = [
    {text: "國有地", code: "nationalLand"},
    {text: "台糖地", code: "taiSugarLand"},
    {text: "私有地-自有(全部自有)", code: "privateOwnedAll"},
    {text: "私有地-自有(有他人持分)", code: "privateOwnedPartial"},
    {text: "私有地-非自有", code: "privateNotOwned"},
];

const months = [
    {code: "Jan", text: "一月"},
    {code: "Feb", text: "二月"},
    {code: "Mar", text: "三月"},
    {code: "Apr", text: "四月"},
    {code: "May", text: "五月"},
    {code: "Jun", text: "六月"},
    {code: "Jul", text: "七月"},
    {code: "Aug", text: "八月"},
    {code: "Sep", text: "九月"},
    {code: "Oct", text: "十月"},
    {code: "Nov", text: "十一月"},
    {code: "Dec", text: "十二月"},
]

const codeUtils = new CodeUtils();
export default codeUtils;

